<template>
  <div>
    <base-title
      :title="StringLanguage.workingTime"
      :subtitle="
        onBoardDone ? StringLanguage.configurations : StringLanguage.back
      "
      :link="onBoardDone ? 'configuracoes' : 'onboard'"
    >
      <base-button text="Limpar" class="w-100" @click="clearWorkingTime" />
    </base-title>

    <div
      v-for="(period, periodIndex) in horaries"
      :key="periodIndex"
      :id="`period-${periodIndex}`"
    >
      <div
        v-if="period.days.length > 0"
        class="period-box"
        :class="{ removing: period.remove }"
      >
        <div v-if="isMobile" class="period-week mobile">
          <Splide :options="options">
            <template v-slot:controls>
              <div class="splide__arrows">
                <button class="splide__arrow splide__arrow--prev arrow-prev">
                  <i class="fal fa-chevron-left" />
                </button>
                <button class="splide__arrow splide__arrow--next arrow-next">
                  <i class="fal fa-chevron-right" />
                </button>
              </div>
            </template>

            <SplideSlide
              v-for="(day, dayIndex) in period.days"
              :key="dayIndex"
              class="period-day"
            >
              <div class="day-box">
                <base-checkbox
                  @click="activeDay(period.period, day)"
                  v-model="day.active"
                  :checked="day.active"
                  center
                >
                  <p class="day">
                    {{ dayNames[(day.weeknum || dayIndex + 1) % 7] }}
                  </p>
                </base-checkbox>
              </div>

              <!-- periodos -->
              <div
                :class="`day-periods ${day.active ? 'active' : 'inactive'}`"
                v-for="(periodNumber, periodIndex) in getPeriodsArray(day)"
                :key="periodIndex"
              >
                <div class="horaries">
                  <div class="day-horaries">
                    <div class="period-title">
                      <base-label class="mb_0"
                        >{{ StringLanguage.period }}
                        {{ periodNumber }}</base-label
                      >
                      <base-button
                        v-if="day.open.length > 1 && periodIndex !== 0"
                        design="four-mini"
                        @click="remove(day.weeknum, periodIndex)"
                      >
                        <i class="fal fa-trash-alt" />
                      </base-button>
                    </div>
                    <Horary
                      :dataOpen="day.open[periodIndex] || null"
                      :dataClose="day.close[periodIndex] || null"
                      :horaries="horaries"
                      :weekday="day"
                      :period="periodNumber"
                      @changePeriod="
                        (v) => onChangePeriod({ day, period: v, periodIndex })
                      "
                    />
                    <template slot="caret">
                      <div class="chevron">
                        <i class="far fa-chevron-down"></i>
                      </div>
                    </template>
                  </div>
                </div>
                <base-add
                  v-if="canAddPeriod(day)"
                  @click.native="add(day.weeknum)"
                  text="Adicionar período"
                  height="235px"
                  class="mt_30"
                />
              </div>
            </SplideSlide>
          </Splide>
        </div>

        <div v-if="!isMobile" class="period-week desktop">
          <div
            v-for="(day, dayIndex) in period.days"
            :key="day.weeknum"
            class="period-day"
          >
            <!-- dias da semana -->
            <div class="day-box">
              <base-checkbox
                @click="activeDay(period.period, day)"
                v-model="day.active"
                :checked="day.active"
                center
              >
                <p class="day">
                  {{ dayNames[(day.weeknum || dayIndex + 1) % 7] }}
                </p>
              </base-checkbox>
            </div>

            <!-- periodos -->
            <div
              :class="`day-periods ${day.active ? 'active' : 'inactive'}`"
              v-for="(periodNumber, periodIndex) in getPeriodsArray(day)"
              :key="periodIndex"
            >
              <div class="horaries">
                <div class="day-horaries">
                  <div class="period-title">
                    <base-label class="mb_0"
                      >{{ StringLanguage.period }}
                      {{ periodNumber }}</base-label
                    >
                    <base-button
                      v-if="day.open.length > 1 && periodIndex !== 0"
                      design="four-mini"
                      @click="remove(day.weeknum, periodIndex)"
                    >
                      <i class="fal fa-trash-alt" />
                    </base-button>
                  </div>
                  <Horary
                    :dataOpen="day.open[periodIndex] || null"
                    :dataClose="day.close[periodIndex] || null"
                    :horaries="horaries"
                    :weekday="day"
                    :period="periodNumber"
                    @changePeriod="
                      (v) => onChangePeriod({ day, period: v, periodIndex })
                    "
                  />
                  <template slot="caret">
                    <div class="chevron">
                      <i class="far fa-chevron-down"></i>
                    </div>
                  </template>
                </div>
              </div>
              <base-add
                v-if="canAddPeriod(day)"
                @click.native="add(day.weeknum)"
                text="Adicionar período"
                height="235px"
                class="mt_30"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex justify-end w-100" v-if="hasChanges()">
      <base-button design="save" @click="onSave" />
    </div>
  </div>
</template>
<script>
/* eslint-disable no-plusplus */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-restricted-globals */
/* eslint-disable no-alert */
/* eslint-disable import/order */
/* eslint-disable import/no-unresolved */
/* eslint-disable import/extensions */
/* eslint-disable no-param-reassign */
import WorkingTime from '@/plugins/core/schema/configurations/WorkingTime/WorkingTime';
import AppBridge from '@/plugins/app';
import StoreAPI from '@/api/store';
import Vue from 'vue';

import { Splide, SplideSlide } from '@splidejs/vue-splide';
// eslint-disable-next-line import/no-extraneous-dependencies
import '@splidejs/splide/dist/css/themes/splide-default.min.css';

import '@/assets/css/veasy/select.css';
import { mapState } from 'vuex';
import BaseTitle from '@/components/Title';
import BaseButton from '@/components/Button';
import BaseBox from '@/components/Box';
import BaseInput from '@/components/Input';
import BaseCheckbox from '@/components/Checkbox';
import BaseLabel from '@/components/Label';
import BaseDrawer from '@/components/Drawer';
import BaseCard from '@/components/Card';
import BaseSelect from '@/components/Select';
import BaseAdd from '@/components/Add';
import Horary from '@/components/Horary';
import Button from '../../components/Button.vue';

const MAX_PERIODS_PER_DAY = 2;

export default {
  data() {
    return {
      MAX_PERIODS_PER_DAY,
      newTimer: [],
      dayNames: WorkingTime.getWeekDays(),
      horaries: [WorkingTime.getTemplatePeriodWeek(1)],
      originalData: [WorkingTime.getTemplatePeriodWeek(1)],
      options: {
        pagination: false,
        padding: 20,
        updateOnMove: false,
        classes: {
          prev: 'splide__arrow--prev arrow-prev',
          next: 'splide__arrow--next arrow-next',
        },
      },
    };
  },
  created() {
    const self = this;
    StoreAPI.storeGetConfiguration('working_time').then((response) => {
      self.set(response);
    });
    // desativado por incompatibilidade com select
    AppBridge.emit('setActivePullRefresh', false);
  },
  beforeRouteLeave(to, from, next) {
    AppBridge.emit('setActivePullRefresh', true);

    if (!this.onBoardDone) {
      return next();
    }

    if (this.hasChanges()) {
      confirm(`${StringLanguage.confirmComplement}`, (res) => res && next());
      return;
    }

    next();
  },
  computed: {
    ...mapState({
      isMobile: (state) => state.store.isMobile,
      onBoardDone: (state) => state.store.onBoardDone,
    }),
  },
  methods: {
    clearWorkingTime() {
      this.horaries = [WorkingTime.getTemplatePeriodWeek(1)];

      this.horaries.forEach((period) => {
        period.days.forEach((day) => {
          day.active = false;
          day.open = [];
          day.close = [];
          day.nextDay = false;
        });
      });

      this.$forceUpdate();
    },
    getTimeRange() {
      const timeHourOptions = [];
      for (let hours = 0; hours < 24; hours++) {
        for (let minutes = 0; minutes < 4; minutes++) {
          timeHourOptions.push(
            `${`${hours}`.padStart(2, '0')}:${`${minutes * 15}`.padStart(
              2,
              '0'
            )}`
          );
        }
      }
      return timeHourOptions;
    },
    getPeriodsArray(day) {
      return new Array(Math.min(day.open.length || 1, MAX_PERIODS_PER_DAY))
        .fill(0, 0, day.open.length || 1)
        .map((item, itemIndex) => itemIndex + 1);
    },
    cleanWorkingTime(time) {
      return String(time).replace(':', '');
    },
    correctPeriods(periods) {
      periods.forEach((period) => {
        period.days.forEach((day) => {
          day.active = !!day.active;
          day.open = day.open.map((openTime) =>
            this.cleanWorkingTime(openTime)
          ); // Remove os : do horario
          day.close = day.close.map((closeTime) =>
            this.cleanWorkingTime(closeTime)
          ); // Remove os : do horario
        });
      });

      return periods;
    },
    onChangePeriod({ day, period, periodIndex }) {
      const timeRange = this.getTimeRange();

      day.open[periodIndex] = period.open;
      day.close[periodIndex] = period.close;
      day.nextDay = period.nextDay;
      day.periodOfNextDay = period.periodOfNextDay;

      // Se a data avança até o dia seguinte
      if (day.nextDay) {
        if (
          Object.values(day.periodOfNextDay).filter(
            (checkedPeriod) => checkedPeriod === true
          ).length > 1
        ) {
          this.horaries[0].days[day.weeknum - 1].open.pop();
          this.horaries[0].days[day.weeknum - 1].close.pop();
          day.periodOfNextDay = { 1: day.periodOfNextDay[1], 2: false };
        }

        const tomorrowWeekNumIndex = day.weeknum % 7;
        const tomorrow = this.horaries[0].days[tomorrowWeekNumIndex];
        // Se o horario de amanhã for menor do que o horário de hoje
        if (
          !tomorrow.open[0] ||
          +tomorrow.open[0] <= +day.close[day.close.length - 1]
        ) {
          const todayCloseIndex = this.indexOfTime(
            day.close[day.close.length - 1]
          );
          const nextTimeIndex = (todayCloseIndex + 1) % timeRange.length;

          if (tomorrow.open[0] && tomorrow.close[0]) {
            tomorrow.open[0] = timeRange[nextTimeIndex];
            tomorrow.close[0] = timeRange[nextTimeIndex + 1];
          }
        }
      }

      this.$forceUpdate();
    },
    indexOfTime(time) {
      const timeRange = this.getTimeRange();
      return timeRange.indexOf(time);
    },
    canAddPeriod(day) {
      // Se o dia tem dois ou mais periodos não é possível adicionar um novo periodo ao dia
      if (day.open.length >= MAX_PERIODS_PER_DAY) {
        return false;
      }

      if (day.close.length === 1 && day.close[0] === '23:45') return false;

      // Se periodo invade o dia seguinte, não é possível adicionar um novo periodo ao dia
      if (
        day.nextDay === undefined &&
        day.open.length > 0 &&
        day.close.length > 0
      ) {
        return this.indexOfTime(day.open[0]) < this.indexOfTime(day.close[0]);
      }

      return !day.nextDay;
    },
    hasChanges() {
      const cleanedHoraries = this.correctPeriods(
        JSON.parse(JSON.stringify(this.horaries))
      );

      const cleanedOriginalHoraries = this.correctPeriods(
        JSON.parse(JSON.stringify(this.originalData))
      );

      // Faz a comparação por string dos dois objetos
      return (
        JSON.stringify(cleanedHoraries) !==
        JSON.stringify(cleanedOriginalHoraries)
      );
    },
    onSave() {
      if (this.hasChanges()) {
        if (this.validateDays()) {
          this.save();
        }
      } else {
        alert(StringLanguage.noChanges);
      }
    },
    set(response) {
      if (response.getErrors([]).length > 0) {
        return;
      }

      let horaries = new WorkingTime([WorkingTime.getTemplatePeriodWeek(1)])
        .periods;
      let originalData = new WorkingTime([WorkingTime.getTemplatePeriodWeek(1)])
        .periods;
      if (response.getData({ working_time: [] }).working_time || false) {
        // Obtem os dados que vem da api ou então cria uma array default
        const periods =
          response.getData({ working_time: [] }).working_time || [];

        // Com base nos peridos retornados, recria o objeto WorkingTime
        const workingTime =
          periods.length > 0
            ? periods
            : [WorkingTime.getTemplatePeriodWeek(1, false)];

        horaries = new WorkingTime(JSON.parse(JSON.stringify(workingTime)))
          .periods;
        originalData = new WorkingTime(JSON.parse(JSON.stringify(workingTime)))
          .periods;
      }

      if (!this.onBoardDone) {
        horaries.forEach((period) => {
          period.days.forEach((day) => {
            if (day.open.length === 0 && day.close.length === 0)
              day.active = false;
          });
        });
      }

      Vue.set(this, 'horaries', horaries);
      Vue.set(this, 'originalData', originalData);
    },
    add(weeknum) {
      const timeRange = this.getTimeRange();
      const day = this.horaries[0].days[weeknum - 1];
      const dayPeriodsLength = day.open.length;

      if (dayPeriodsLength > 0) {
        const lastPeriodClose = day.close[dayPeriodsLength - 1];
        const newOpenIndex =
          (timeRange.indexOf(lastPeriodClose) + 1) % timeRange.length;
        day.open.push(timeRange[newOpenIndex]);
        day.close.push(timeRange[newOpenIndex + 1] || '00:00');
      } else {
        day.open.push(timeRange[0]);
        day.close.push(timeRange[1]);
      }

      const openTimeStr = +day.open[dayPeriodsLength].replace(':', ''); // 20:30 -> 2030
      const closeTimeStr = +day.close[dayPeriodsLength].replace(':', ''); // 00:15 -> 0015
      day.nextDay = closeTimeStr < openTimeStr;

      this.$forceUpdate();
    },
    remove(weeknum, n) {
      const dayIndex = weeknum - 1;
      this.horaries[0].days[dayIndex].open.splice(n, 1);
      this.horaries[0].days[dayIndex].close.splice(n, 1);
      this.horaries[0].days[dayIndex].period = 1;
      this.horaries[0].days[dayIndex].nextDay = false;
      this.$forceUpdate();
    },
    validateDays() {
      let invalidDays = false;
      let hasActiveDays = false;

      this.horaries.forEach((period) => {
        period.days.forEach((day) => {
          // Se o dia estiver ativo
          if (day.active) {
            hasActiveDays = true;
            // Se não tiver horários configurados para abertura
            // Se não tiver horários configurados para fechamento
            // Se não tiver horários configurados para horários forem diferentes entre sí
            if (
              !day.open.length ||
              !day.close.length ||
              day.open.length !== day.close.length
            ) {
              invalidDays = true;
            }

            if (
              (parseInt(day.open[0], 10) > parseInt(day.close[0], 10) ||
                parseInt(day.open[1], 10) > parseInt(day.close[1], 10)) &&
              !day.nextDay
            ) {
              day.closeTimeIsValid = false;
            }

            if (day.open === day.close) {
              if (day.open === '23:59') day.openTimeIsValid = false;
              else day.closeTimeIsValid = false;
            }
          }
        });
      });

      if (!hasActiveDays) {
        alert('Ative ao menos um dia');
        return false;
      }

      if (invalidDays) {
        alert('Preencha os horários dos dias selecionados.');
        return false;
      }
      return true;
    },
    save() {
      const self = this;
      const horaries = this.correctPeriods(
        JSON.parse(JSON.stringify(this.horaries))
      );

      return StoreAPI.storeConfiguration({
        working_time: horaries,
      }).then((response) => {
        self.set(response);
        // this.$store.dispatch("store/getIsOpen");
        this.$store.dispatch('store/getConfigurations');

        if (!this.onBoardDone) {
          return this.$router.push({ name: 'onboard' });
        }

        alert(StringLanguage.saveSuccess);
      });
    },
    activeDay(period, day) {
      period = day;
    },
  },
  components: {
    BaseTitle,
    BaseButton,
    BaseBox,
    BaseInput,
    BaseCheckbox,
    BaseLabel,
    BaseDrawer,
    BaseCard,
    BaseSelect,
    BaseAdd,
    SplideSlide,
    Splide,
    Horary,
    Button,
  },
};
</script>
<style scoped>
.period-box {
  opacity: 1;
  transition: 0.2s linear;
}
.period-box.removing {
  opacity: 0;
}
.period-title {
  padding-bottom: 15px;
  margin-bottom: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  height: 50px;
  padding: 5px 0;
}
.period-week {
  display: flex;
}
.period-day {
  width: 100%;
}
.day-periods.active {
  opacity: 1;
}
.day-periods.inactive {
  opacity: 0.5;
  pointer-events: none;
}
.day-periods {
  padding: 20px 0 10px;
}
.day-periods > .horaries {
  background-color: var(--box);
  border-radius: 5px;
  padding: 0 15px 15px;
}
.day-box {
  opacity: 1;
  padding: 20px;
  background: var(--background);
}
.period-day .day-box {
  border-radius: 5px;
}
.start-end {
  color: #d9d9d9bf;
}
.start-end .next-day {
  color: #fc9;
  font-weight: 300;
}
.hairline {
  height: 20px;
  border-left: 1px solid rgba(255, 255, 255, 0.2);
  margin: 5px 0 15px;
}
.tz-value {
  font-size: 1.4em;
  padding: 15px 20px;
  background: #f6f6f6;
  color: #999;
  margin-top: 20px;
}
.tz-value span {
  font-weight: 600;
}
.day {
  font-size: 12px;
}
@media screen and (min-width: 992px) {
  .period-week.desktop {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 20px;
  }
  .period-week.mobile {
    display: none;
  }
}
@media screen and (max-width: 991px) {
  .period-title {
    margin-bottom: 15px;
  }
  .period-week {
    flex-direction: column;
  }
  .period-week.desktop {
    display: none;
  }
  .period-day .day-horaries {
    flex-direction: column;
  }
  .period-day.opened .day-horaries {
    display: block;
    margin-bottom: 10px;
  }
  .period-day {
    margin-right: 0;
    border-right: none;
    margin-bottom: 10px;
    padding: 0 5px;
  }
  .period-day:first-child {
    padding-left: 0;
  }
  .day-horaries {
    display: flex;
  }
  .day-periods {
    padding: 0;
    margin-top: 10px;
  }
  .day-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    border-radius: 5px;
  }
  .arrow-next,
  .arrow-prev {
    top: 28px;
    padding: 0 10px;
    background: 0 0;
    color: #8c8c8c;
    height: 40px;
    width: 50px;
  }
  .arrow-next[disabled],
  .arrow-prev[disabled] {
    display: none;
  }
  .arrow-prev {
    left: 25px;
  }
  .arrow-next {
    right: 25px;
  }
}
</style>
